<template>
  <v-tooltip
    v-if="$vuetify.breakpoint.smAndUp"
    bottom
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :aria-label="$t('app.changeThemeColour')"
        icon
        @click.stop="darkMode = !darkMode"
        v-on="on"
      >
        <v-icon>
          mdi-theme-light-dark
        </v-icon>
      </v-btn>
    </template>
    <span>{{ $t('app.changeThemeColour') }}</span>
  </v-tooltip>
  <v-btn
    v-else
    :aria-label="$t('app.changeThemeColour')"
    icon
    @click.stop="darkMode = !darkMode"
  >
    <v-icon>
      mdi-theme-light-dark
    </v-icon>
  </v-btn>
</template>

<script>
// TODO Poprawić działanie tooltipa i jego 'chowanie na mniejszych rozdzielczościach'
export default {
  name: 'ButtonChangeTheme',
  data: () => ({
    publicPath: process.env.BASE_URL,
    welcomeAudioPlaying: undefined
  }),
  computed: {
    darkMode: {
      get () {
        return this.$store.state.darkMode
      },
      set (value) {
        this.$store.commit('setDarkMode', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
